import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  symbol: String;

  constructor() {
    this.symbol = "AAPL";
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts